<template>
  <div>
    <v-card flat>
      <v-tabs centered>
        <v-tab @click="tab = 2">
          <v-icon left>mdi-home-variant</v-icon>
          Grupo
        </v-tab>
        <v-tab @click="tab = 3">
          <v-icon left>mdi-home-group</v-icon>
          Grupos Filiais
        </v-tab>

        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <Grupos />
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <GrupoFilial :atualizar="tab" />
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>

<script>
import Grupos from "@/components/cfg/CfgGrupos";
import GrupoFilial from "@/components/cfg/CfgGrupoFilial";

export default {
  components: { Grupos, GrupoFilial },
  data: () => ({
    tab: null
  })
}
</script>
